import { useEffect, useMemo, useRef, useState } from "react";
import LocationModal from "./LocationModal";
import FullScheduleModal from "./FullScheduleModal";
import { useAppContext } from "../../contexts/AppContext";
import {
  Modal,
  ModalHeader,
  Spinner,
  
} from "react-bootstrap";
import Select from "react-select";
import {
  getAllGroupMembers,
  queryGroups,
} from "../../services/poweruserServices";
import axios from "axios";
import ConfirmationScreen from "./ConfirmationScreen";

import onsite from "./../../assets/Vector.svg";
import online from "./../../assets/Online.svg";
import CustomTooltip from "./CustomTooltip/CustomTooltip";
import EnrollPDFMyDocument from "./EnrollPDF/EnrollPDFMyDocument"
import { pdf } from "@react-pdf/renderer";
import JSZip from "jszip";
import { saveAs } from "file-saver";
const ScheduleList = ({
  isBT30,
  isAvailableCountLoading,
  groupedSession,
  groupedSession2,
  cities,
  selectedLearningPlan,
  handleSelectedSessionToParent,
  onGoToEnrollmentClick,
  conformationText,
}) => {
  const { currentUser } = useAppContext();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedCities, setSelectedCities] = useState([]);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showViewFullScheduleList, setShowViewFullScheduleList] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [showViewSessionConfirm, setShowViewSessionConfirm] = useState(false);
  const [otherSessionList, setotherSessionList] = useState([]);
  const [enrolledSessionList, setEnrolledSessionList] = useState([]);
  const [sessionForEnroll, setSessionForEnroll] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCityAddress, setSelectedCityAddress] = useState("");
  const [showEnrollModal, setShowEnrollModal] = useState(false);
  const [selectBoxValues, setSelectBoxValues] = useState();
  const [showEnrollConfirm, setShowEnrollConfirm] = useState(false);
  const [sessionLength, setSessionLength] = useState(0);
  const enrollSelectBox = useRef(null);
  const [defaultListGroupOptions, setDefaultListGroupOptions] = useState([]);
  const [isListBoxLoading, setIsListBoxLoading] = useState(false);
  const [selectBoxValuesGroup, setSelectBoxValuesGroup] = useState();
  const [groupUsers, setGroupUsers] = useState([]);
  const [defaultListOptions, setDefaultListOptions] = useState([]);
  const [status, setStatus] = useState("");
  const [selectedCohort, setSelectedCohort] = useState([]);
  const [result, setResult] = useState({});
  const [showResult, setShowResult] = useState(false);
  const [prowerUserMsg, setProwerUserMsg] = useState(false);
  const [selectBoxValuesUser, setSelectBoxValuesUser] = useState(null);
  const [showViewDashboardPopup, setShowViewDashboardPopup] = useState(false);
  const sessionForEnrollSelectionRef = useRef([]);
  const hasTriggeredRef = useRef(false);
  const [hasZeroSeats, setHasZeroSeats] = useState(false);
  const [expandedRegions, setExpandedRegions] = useState({});

  useEffect(() => {
    if (showViewFullScheduleList && !hasTriggeredRef.current) {
      onViewSessionClickHandler(sessionForEnrollSelectionRef.current);
      hasTriggeredRef.current = true;
    }
  }, [isAvailableCountLoading]);

  const formatDate = (dateStr) => {
    const options = {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    };
    return new Date(dateStr).toLocaleDateString("en-US", options);
  };
  const formatTime = (dateStr) => {
    const options = { hour: "numeric", minute: "numeric", hour12: true };
    return new Date(dateStr).toLocaleTimeString("en-US", options);
  };

  // const filteredRecords = () => {
  //   if (!groupedSession) return [];
  //   return groupedSession.map((session) => {
  //     const locationObj = session.sessions[0].location;
  //     const courseId = session.sessions[0].courseid;
  //     const course = selectedLearningPlan.courses.find(
  //       (c) => c.id_course === courseId
  //     );
  //     const moduleName = course ? course?.name : "Unknown Module";

  //     return {
  //       date: formatDate(session.sessions[0].startdatetime),
  //       time: formatTime(session.sessions[0].startdatetime),
  //       startTime: formatTime(session.sessions[0].date_start),
  //       endTime: formatTime(session.sessions[0].date_end),
  //       rawDate: new Date(session.sessions[0].startdatetime),
  //       locationType: session.sessions[0].attendance_type,
  //       duration: session.sessions[0].hours,
  //       module: moduleName,
  //       seats:
  //         parseInt(session.sessions[0].max_enroll) -
  //         parseInt(session.sessions[0].enrolled),
  //       city:
  //         session.sessions[0].cityname === "Webinar"
  //           ? "Online"
  //           : session.sessions[0].cityname || "-",
  //       cityLinkText:
  //         session.sessions[0].attendance_type === "online" ||
  //         session.sessions[0].cityname === "Webinar"
  //           ? ""
  //           : session.sessions[0].cityname,
  //       cityLink: session.sessions[0].location || "#",
  //       locationInfo: {
  //         name: locationObj?.name,
  //         address: locationObj?.address,
  //         mapLink: locationObj?.address,
  //       },
  //       sessions: session,
  //     };
  //   });
  // };

  const filteredRecords = () => {
    if (!groupedSession) return [];

    return groupedSession.map((session) => {
      const locationObj = session.sessions[0].location;
      const courseId = session.sessions[0].courseid;
      const course = selectedLearningPlan.courses.find(
        (c) => c.id_course === courseId
      );
      const moduleName = course ? course.name : "Unknown Module";

      const seatSession = groupedSession2?.filter(
        (x) => x.id == session.sessions[0].id
      );

      const seats = Number.isNaN(
        Number(seatSession?.[0]?.max_enroll) -
          Number(seatSession?.[0]?.enrolled)
      )
        ? 0
        : Number(seatSession?.[0]?.max_enroll) -
          Number(seatSession?.[0]?.enrolled);

      return {
        date: formatDate(session.sessions[0].startdatetime),
        time: formatTime(session.sessions[0].startdatetime),
        startTime: formatTime(session.sessions[0].date_start),
        endTime: formatTime(session.sessions[0].date_end),
        rawDate: new Date(session.sessions[0].startdatetime),
        locationType: session.sessions[0].attendance_type,
        duration: session.sessions[0].hours,
        module: moduleName,
        seats,
        city:
          session.sessions[0].cityname === "Webinar"
            ? "Online"
            : session.sessions[0].cityname || "-",
        cityLinkText:
          session.sessions[0].attendance_type === "online" ||
          session.sessions[0].cityname === "Webinar"
            ? ""
            : session.sessions[0].cityname,
        cityLink: session.sessions[0].location || "#",
        locationInfo: {
          name: locationObj?.name,
          address: locationObj?.address,
          mapLink: locationObj?.address,
        },
        sessions: session,
      };
    });
  };

  const scheduleData = filteredRecords();

  const groupedCities = cities.reduce((acc, city) => {
    if (!acc[city.regionname]) acc[city.regionname] = [];
    acc[city.regionname].push(city.name);
    return acc;
  }, {});

  const handleCityToggle = (city) => {
    setSelectedCities((prev) =>
      prev.includes(city) ? prev.filter((c) => c !== city) : [...prev, city]
    );
  };

  const filteredSchedule = useMemo(() => {
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
    if (to) {
      to.setHours(23, 59, 59, 999);
    }

    return scheduleData.filter((entry) => {
      if (from && entry.rawDate < from) return false;
        if (to && entry.rawDate > to) return false;
        const city = entry.city === "Online" ? "Webinar" : entry.city;
        if (selectedCities.length > 0 && !selectedCities.includes(city))
        return false;
      return true;
    });
  }, [scheduleData, fromDate, toDate, selectedCities]);

  const onViewSessionClickHandler = async (session) => {
    const sorted = [...session].sort(
      (a, b) => new Date(a.date_start) - new Date(b.date_start)
    );

    var dataAranged = sorted.map((session) => {
      const courseId = session.courseid;
      const course = selectedLearningPlan.courses.find(
        (c) => c.id_course === courseId
      );
      const moduleName = course ? course?.name : "Unknown Module";

      const seatSession = groupedSession2?.filter((x) => x.id === session.id);

      const seats = Number.isNaN(
        Number(seatSession?.[0]?.max_enroll) -
          Number(seatSession?.[0]?.enrolled)
      )
        ? 0
        : Number(seatSession?.[0]?.max_enroll) -
          Number(seatSession?.[0]?.enrolled);

      return {
        date: formatDate(session.startdatetime),
        time: formatTime(session.startdatetime),
        startTime: formatTime(session.date_start),
        endTime: formatTime(session.date_end),
        rawDate: new Date(session.startdatetime),
        locationType: session.attendance_type,
        duration: session.hours,
        module: moduleName,
        seats: seats,
        city:
          session.cityname === "Webinar" ? "Online" : session.cityname || "-",
        cityLinkText:
          session.attendance_type === "online" || session.cityname === "Webinar"
            ? ""
            : session.cityname,
        cityLink: session.location || "#",
        courseId: session.courseid,
      };
    });

    setSelectedCity(session[0].cityname);
    setSelectedCityAddress(session[0].location?.name);

    const groupedSchedule = Object.entries(
      dataAranged.reduce((acc, entry) => {
        (acc[entry.date] ??= []).push(entry);
        return acc;
      }, {})
    ).sort(
      ([, entriesA], [, entriesB]) =>
        new Date(entriesA[0].rawDate) - new Date(entriesB[0].rawDate)
    );

    const hasZeroSeats = groupedSchedule.some(([, entries]) =>
      entries.some((entry) => entry.seats === 0)
    );

    setHasZeroSeats(hasZeroSeats);

    setotherSessionList(groupedSchedule);
    setEnrolledSessionList(groupedSchedule);
    setSessionForEnroll(session);
    setShowViewSessionConfirm(true);
  };

  const enrollInCoursesAndSessions = async (
    userIds,
    groupIds,
    branchIds,
    selectedSessions
  ) => {
    var resultObj = {};

    try {
      if (userIds.length > 0) {
        setStatus("Enrolling users to learning plan..");

        const userResp = await axios.post(
            `${process.env.REACT_APP_API_DOMAIN}/enrollment/users_to_lp${window.location.search}`,
          {
            userIds,
            learningPlanId: selectedLearningPlan.id,
          },
          { withCredentials: true }
        );

        resultObj.userToLpResult = userResp;
      }

      if (groupIds.length > 0) {
        setStatus("Enrolling group to learning plan..");

        const groupResp = await axios.post(
            `${process.env.REACT_APP_API_DOMAIN}/enrollment/groups_to_lp${window.location.search}`,
          {
            groupIds,
            learningPlanId: selectedLearningPlan.id,
          },
          { withCredentials: true }
        );

        resultObj.groupToLpResult = groupResp;
      }

      if (branchIds.length > 0) {
        setStatus("Enrolling branches to learning plan..");

        const branchResp = await axios.post(
            `${process.env.REACT_APP_API_DOMAIN}/enrollment/branches_to_lp${window.location.search}`,
          {
            branchIds,
            learningPlanId: selectedLearningPlan.id,
          },
          { withCredentials: true }
        );

        resultObj.branchToLpResult = branchResp;
      }

      let userErrors = resultObj?.userToLpResult?.data?.filter(
        (d) => d.status >= 400
      );
      let groupErrors = resultObj?.groupToLpResult?.data?.filter(
        (d) => d.status >= 400
      );
      let branchErrors = resultObj?.branchToLpResult?.data?.filter(
        (d) => d.status >= 400
      );

      if (userErrors || groupErrors || branchErrors) {
      } else {
        setStatus("Learning plan enrollment completed..");
      }

      setStatus("Fetching sessions..");

      let getPastSessions = currentUser.isPowerUser; //power user can see past sessions

      setStatus("Enrolling to sessions..");

      let sessions = selectedCohort.map((s) => {
        return { sessionId: s.id, courseId: s.courseid };
      });

      resultObj = {};

      let sessionResponse = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment${window.location.search}`,
        {
          userIds,
          groupIds,
          branchIds,
          sessions: sessions,
        },
        { withCredentials: true }
      );

      if (sessionResponse?.data) {
        let existingEnrollments=[];
        resultObj.enrolled = sessionResponse.data
          .map((d) => d?.enrolled)
          .flat(1)
          .filter((e) => e != null);
        if(currentUser.isPowerUser)
        {
          
existingEnrollments = sessionResponse.data
  .flatMap(d => {
    // Case 1: errors.existing_enrollments (object form)
    if (Array.isArray(d?.errors?.existing_enrollments)) {
      return d.errors.existing_enrollments;
    }

    // Case 2: errors is directly an array
    if (Array.isArray(d?.errors)) {
      return d.errors;
    }

    return [];
  })
  .filter(e => e != null);


        resultObj.existing_enrollments = existingEnrollments;
        
 resultObj.extsingEnroll_Data= sessionResponse.data
  .flatMap(d => {
    if (Array.isArray(d?.errors)) {
      // Case: errors is an array
      return d.errors;
    }

    if (Array.isArray(d?.errors?.existing_enrollments)) {
      // Case: errors.existing_enrollments
      return d.errors.existing_enrollments;
    }

    return [];
  })
  .map(str => {
    const match = str.match(/id_user:\s*(\d+)\s+and\s+id_course:\s*(\d+)/);

    if (!match) return null;

    return {
      id_user: Number(match[1]),
      id_course: Number(match[2]),
      waiting: false
    };
  })
  .filter(Boolean);

console.log( resultObj.extsingEnroll_Data,"resultObj.extsingEnroll_Data");

        resultObj.errors = 
sessionResponse.data
  .flatMap(d => {
    // Case 1: errors.existing_enrollments (object form)
    if (Array.isArray(d?.errors?.existing_enrollments)) {
      return d.errors.existing_enrollments;
    }

    // Case 2: errors is directly an array
    if (Array.isArray(d?.errors)) {
      return d.errors;
    }

    return [];
  })
  .filter(e => e != null);


const pendingSessions = selectBoxValues.flatMap(user => {
  const userId = user.value;


  return selectedCohort
    ?.filter(session =>
      !resultObj.enrolled.some(
        e => e.id_user === userId && e.id_course === Number(session.courseid)
      ) &&
      !resultObj.extsingEnroll_Data.some(
        e => e.id_user === userId && e.id_course === Number(session.courseid)
      )
    )
    .map(session => ({
      id_user: userId,
      id_course: session.courseid,
      waiting: false
    })) ?? [];
});
 resultObj.penddingsessions = pendingSessions;

        }
        else{
  existingEnrollments = sessionResponse.data
          .map((d) => d?.errors)
          .flat(1)
          .filter((e) => e?.startsWith("The enrollments already exists"));

        resultObj.existing_enrollments = existingEnrollments;

        resultObj.errors = sessionResponse.data
          .map((d) => d?.errors)
          .flat(1)
          .filter(
            (e) =>
              !e?.startsWith("The enrollments already exists") && e != null,
          );
        }
       

        

        const enrolledCourseIds =
          resultObj.enrolled?.map((item) => item.id_course.toString()) || [];

        const unableToJoinSessions = selectedSessions.filter(
          (item) => !enrolledCourseIds.includes(item.courseid)
        );

        setEnrolledSessionList((prevList) =>
          prevList.map((group) => {
            const updatedSessions = group["1"].map((session) => {
              const alreadyExists = resultObj.existing_enrollments?.some(
                (msg) => msg.includes(`id_course: ${session.courseId}`)
              );

              let enrolledStatus = "Not Enrolled";

              if (alreadyExists) {
                enrolledStatus = "Already Enrolled";
              } else if (
                enrolledCourseIds.includes(session.courseId?.toString())
              ) {
                enrolledStatus = "Enrolled";
              }

              return {
                ...session,
                enrolledStatus,
              };
            });

            return {
              ...group,
              1: updatedSessions,
            };
          })
        );
if(currentUser.isPowerUser===false)
{
 if (
          resultObj.enrolled &&
          resultObj.enrolled.length + (existingEnrollments?.length || 0) !==
            selectedCohort.length
        ) {
          const pendingSessions = selectedCohort?.filter((parent) =>
            unableToJoinSessions?.some(
              (item) => item?.courseid === parent?.courseid
            )
          );

          resultObj.penddingsessions = pendingSessions;
        }
}
       

      }
    } catch (error) {
      resultObj.errors = error;
      console.error(error);
    }

    setResult(resultObj);
    setShowResult(true);
    setShowViewFullScheduleList(false);
    setShowEnrollModal(false);
    setShowViewDashboardPopup(true);
  };

  const onModalEnrollClickHandler = async (e) => {
    setLoading(true);
    let users = selectBoxValues.filter((value) => value.type === "user");
    let groups = selectBoxValues.filter((value) => value.type === "group");
    let branches = selectBoxValues.filter((value) => value.type === "branch");

    let userIds = users.map((user) => user.value);
    let groupIds = groups.map((group) => group.value);
    let branchIds = branches.map((branch) => branch.value);

    await enrollInCoursesAndSessions(
      userIds,
      groupIds,
      branchIds,
      selectedCohort
    );
    setShowEnrollModal(false);
    setShowViewSessionConfirm(false);
    setSessionForEnroll([]);
    setLoading(false);
  };

  

  const onConfirmEnrollClick = async () => {
    setLoading(true);
    await enrollUser();
    setLoading(false);
    setShowEnrollModal(false);
    setShowEnrollConfirm(false);
    setShowViewSessionConfirm(false);
    setotherSessionList([]);
    setSessionForEnroll([]);
  };

  const enrollUser = async () => {
    var resultObj = {};
    try {
      let userIds = [currentUser.user_id];
      const userResp = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment/users_to_lp${window.location.search}`,
        {
          userIds,
          learningPlanId: selectedLearningPlan.id,
        },
        { withCredentials: true }
      );

      var selectedSessions = selectedCohort.map((s) => {
        return { sessionId: s.id, courseId: s.courseid };
      });

      var branchIds = []; //send in request to avoid errors
      var groupIds = []; //send in request to avoid errors

      var sessionResponse = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment${window.location.search}`,
        {
          userIds,
          groupIds,
          branchIds,
          sessions: selectedSessions,
        },
        { withCredentials: true }
      );

      const existingEnrollments = sessionResponse.data
        .map((d) => d?.errors)
        .flat(1)
        .filter((e) => e?.startsWith("The enrollments already exists"));
      resultObj.existing_enrollments = existingEnrollments;
      resultObj.errors = sessionResponse.data
        .map((d) => d?.errors)
        .flat(1)
        .filter(
          (e) => !e?.startsWith("The enrollments already exists") && e != null
        );

      resultObj.enrolled = sessionResponse.data
        .map((d) => d?.enrolled)
        .flat(1)
        .filter((e) => e != null);

      if (resultObj.enrolled && resultObj.enrolled.length > 0) {
        let exixtingenroll = 0;
        if (
          resultObj.existing_enrollments &&
          resultObj.existing_enrollments.length > 0
        ) {
          //exixtingenroll=resultObj.existing_enrollments.length;
          exixtingenroll = 0;
        }
        if (
          resultObj.enrolled.length + exixtingenroll !==
          selectedCohort.length
        ) {
          const enrolledcorseid = resultObj.enrolled.map((item) =>
            item.id_course.toString()
          );

          const unabletojoinsession = selectedSessions.filter(
            (item) => !enrolledcorseid.includes(item.courseId)
          );

          const penddingsessions = selectedCohort.sessions?.filter((parent) => {
            return unabletojoinsession?.some(
              (item) => item?.courseId === parent?.courseid
            );
          });

          resultObj.penddingsessions = penddingsessions;
        }
      }
      setEnrolledSessionList((prevList) =>
        prevList.map((group) => {
          const updatedSessions = group["1"].map((session) => {
            const alreadyExists = resultObj.existing_enrollments?.some((msg) =>
              msg.includes(`id_course: ${session.courseId}`)
            );

            const enrolledExists = resultObj.enrolled.length > 0;

            let enrolledStatus = "Not Enrolled";

            if (alreadyExists) {
              enrolledStatus = "Already Enrolled";
            } else if (
              selectedSessions.includes(session.courseId?.toString()) ||
              enrolledExists
            ) {
              enrolledStatus = "Enrolled";
            }

            return {
              ...session,
              enrolledStatus,
            };
          });

          return {
            ...group,
            1: updatedSessions,
          };
        })
      );

      setResult(resultObj);
      setShowResult(true);
      setShowEnrollConfirm(false);
      setShowEnrollModal(false);
      setShowViewFullScheduleList(false);
      setShowViewDashboardPopup(true);
    } catch (error) {
      console.error(error);
    }
  };

  const onEnrollClickHandler = () => {
    setSelectedCohort(sessionForEnroll);
    setSelectBoxValues([]);
    if (currentUser.isPowerUser) {
      setShowEnrollModal(true);
    } else {
      setShowEnrollConfirm(true);
    }
  };

  const filterOptions = (candidate, input) => {
  const search = input.toLowerCase();

  return (
    candidate.data.label.toLowerCase().includes(search) ||
    candidate.data.email.toLowerCase().includes(search) ||
    candidate.data.value.toString().toLowerCase().includes(search) ||
    candidate.data.firstname.toLowerCase().includes(search) ||
      candidate.data.lastname.toLowerCase().includes(search) ||

      (candidate.data.firstname + ' ' + candidate.data.lastname)
          .toLowerCase()
          .includes(search)
  );
};

  const getPowerUserGroups = async () => {
    setIsListBoxLoading(true);
    let userGroups = await queryGroups(currentUser.user_id);

    var result = userGroups.map((item) => {
      return { value: item.id, label: item.name, type: "group" };
    });

    setDefaultListGroupOptions(result);
    setIsListBoxLoading(false);

    if (result.length > 0) {
      const firstGroup = result[0];
      setSelectBoxValuesGroup(firstGroup);
      await handleSelectChangeGroup(firstGroup);
    }

    return result;
  };

  const handleSelectChangeGroup = async (selectedOptions) => {
    setIsListBoxLoading(true);
    setSelectBoxValuesGroup(selectedOptions);
    let groupId = selectedOptions.value.toString();
    let groupUsers = await getAllGroupMembers(groupId);

    let listGroupUsers = groupUsers.map((item) => {
      return {
        value: item.id,
        label: item.username+" ( "+item.firstname+" "+item.lastname+" )",
        type: "user",
        email: item.email,
        firstname: item.firstname,
        lastname: item.lastname,
         username:item.username
      };
    });

    setGroupUsers(listGroupUsers);
    setDefaultListOptions(listGroupUsers);
    setIsListBoxLoading(false);
    return listGroupUsers;
  };

  const toggleRegion = (region) => {
    setExpandedRegions((prev) => ({
      ...prev,
      [region]: !prev[region],
    }));
  };
  const handlePrintData = async (enrolledSessionList,result,currentUser) => {
      const enrolledCourseIds = new Set(
          result?.enrolled?.map(e => e.id_course.toString())
      );

      if (enrolledCourseIds.size > 0) {

          const filteredList = enrolledSessionList
              .map(day => {
                  const filteredCourses = day["1"].filter(course =>
                      enrolledCourseIds.has(course.courseId)
                  );

                  if (filteredCourses.length === 0) return null;

                  return {
                      "0": day["0"],
                      "1": filteredCourses
                  };
              })
              .filter(Boolean);
 if(currentUser.isPowerUser===true)
 {
  
const matchedList = selectBoxValues.filter(item =>
  result.enrolled.some(enroll => enroll.id_user === item.value)
);

     const zip = new JSZip();

     for (const item of matchedList) {
         const blob = await pdf(
             <EnrollPDFMyDocument
                 enrolledSessionList={filteredList}
                 result={result}
                 currentUser={currentUser}
                 selectBoxValues={[item]}
             />
         ).toBlob();

         zip.file(item.label + ".pdf", blob);
     }

     const now = new Date();
     const formattedDate = now.toISOString().split("T")[0];
     const customDate = `${now.getDate().toString().padStart(2, "0")}-${(now.getMonth() + 1)
         .toString()
         .padStart(2, "0")}-${now.getFullYear()}`;

     const content = await zip.generateAsync({ type: "blob" });
     saveAs(content, `${currentUser.username}_${customDate}.zip`);
setLoading(false);
 }
 else{
          const blob = await pdf(
              <EnrollPDFMyDocument
                  enrolledSessionList={filteredList}
                  result={result}
                  currentUser={currentUser}
                  selectBoxValues={selectBoxValues}
              />,
          ).toBlob();
          const url = URL.createObjectURL(blob);
          setLoading(false);
          window.open(url, "_blank");
 }
      }
      else {
          const blob = await pdf(
              <EnrollPDFMyDocument
                  enrolledSessionList={[]}
                  result={result}
                  currentUser={currentUser}
                  selectBoxValues={selectBoxValues}
              />,
          ).toBlob();
          const url = URL.createObjectURL(blob);
          setLoading(false);
          window.open(url, "_blank");
      }


       
      
    
  };

  return (
    <div className="schedule-page">
      <div className="filters-panel">
        <div className="date-filter">
          <div className="date-filter-heading">Date Filters</div>
          <div className="date-group">
            <label>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="date-group">
            <label>To Date</label>
            <input
              type="date"
              value={toDate}
              min={fromDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
        </div>

        <div className="location-filter-heading">Location Filters</div>

              {Object.entries(groupedCities).sort(([regionA], [regionB]) =>
                  regionA.localeCompare(regionB)
              ).map(([region, cityNames]) => (
          <div key={region} className="filter-group">
            <div
              className="filter-heading"
              style={{
                fontSize: "16px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>{region}</div>

              <div
                style={{ cursor: "pointer" }}
                onClick={() => toggleRegion(region)}
              >
                {expandedRegions[region] ? "-" : "+"}
              </div>
            </div>

            {expandedRegions[region] &&
              cityNames.map((city, index) => (
                <label key={city} className="filter-option">
                  <input
                    id={index}
                    type="checkbox"
                    checked={selectedCities.includes(city)}
                    onChange={() => handleCityToggle(city)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleCityToggle(city);
                      }
                    }}
                  />
                  <span className="cityList">{city}</span>
                </label>
              ))}
          </div>
        ))}
      </div>

      {isBT30 ? (
        <div className="schedule-bt30-table">
          {filteredSchedule?.length > 0 ? (
            <>
              <div className="bt30-table-header">
                <div>Select</div>
                <div style={{ marginLeft: "10px" }}>Class Date</div>
                <div style={{ marginLeft: "2px" }}>Location</div>
                <div>Available Seats</div>
              </div>

              {filteredSchedule.map((entry, index) => (
                <div key={index} className="bt30-table-row">
                  <div
                    className="table_radio_button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                       
                        e.preventDefault();
                        handleSelectedSessionToParent(entry, true);
                        document.getElementById(`radio-${index}`).checked = true; // ensure visual selection
                      }
                    }}
                  >
                    <input
                      type="radio"
                      style={{ cursor: "pointer" }}
                      name="scheduleSelect"
                      aria-label="schedule"
                      id={`radio-${index}`}
                      value={entry.id}
                      onChange={(e) => {
                        handleSelectedSessionToParent(entry, e.target.checked);
                      }}
                    />
                  </div>
                  <div className="class-date-time">
                    <div className="class-date">{entry.date}</div>
                    <div>
                      {entry.startTime} - {entry.endTime}
                    </div>
                  </div>
                  <div className="bt30-table-location">
                    <div style={{ fontWeight: "bold" }}>{entry.city}</div>
                    <div
                      className="locationLinkTextBt30"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        // support Enter/Space activation
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setSelectedLocation(entry.locationInfo);
                          setShowLocationModal(true);
                        }
                      }}
                      onClick={() => {
                        setSelectedLocation(entry.locationInfo);
                        setShowLocationModal(true);
                      }}
                    >
                      {entry.locationInfo.name}
                    </div>
                  </div>
                  {/* {currentUser.isPowerUser && ( */}
                  {!isAvailableCountLoading ? (
                    <div
                      style={{
                        color:
                          entry.seats > 0 ? "black" : "#be0606",
                        fontWeight:"bold" ,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      {entry.seats}
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      <Spinner
                        className="me-1"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    </div>
                  )}
                  {/* )} */}
                </div>
              ))}
            </>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "200px",
              }}
            >
              No record(s) found.
            </div>
          )}
        </div>
      ) : (
        <div className="schedule-table">
          {filteredSchedule?.length > 0 && (
            <div className="table-header">
              <div
                style={{
                  // minWidth: currentUser.isPowerUser ? "120px" : "140px",
                  // marginRight: currentUser.isPowerUser ? "18px" : "20px",
                   minWidth: "120px" ,
                  marginRight: "18px" ,
                }}
              >
                Start Date & Time
              </div>
              <div
                style={{
                  //marginLeft: currentUser.isPowerUser ? "10px" : "0px",
                  marginLeft:  "10px" ,
                }}
              >
                Location
              </div>
              {/* {currentUser.isPowerUser && <div>Available Seats</div>} */}
                 <div>Available Seats</div>
              <div></div>
            </div>
          )}

          {filteredSchedule?.length > 0 ? (
            filteredSchedule.map((entry, index) => (
              <div key={index} className="table-row">
                <div
                  className="class-date-time"
                  style={{
                   // minWidth: currentUser.isPowerUser ? "140px" : "140px",
                      minWidth:  "140px" ,
                  }}
                >
                  <div className="class-date">{entry.date}</div>
                  <div className="class-time">{entry.time}</div>
                </div>
                <div className="bt30-table-location">
                  <div
                    style={{
                      fontWeight: "bold",
                      // marginLeft: currentUser.isPowerUser ? "10px" : "20px",
                      // minWidth: currentUser.isPowerUser ? "150px" : "200px",
                       marginLeft:  "10px" ,
                      minWidth:  "150px",
                    }}
                  >
                    {entry.city}
                  </div>
                  <div
                    className="locationLinkText"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setSelectedLocation(entry.locationInfo);
                        setShowLocationModal(true);
                      }
                    }}
                    onClick={() => {
                      setSelectedLocation(entry.locationInfo);
                      setShowLocationModal(true);
                    }}
                    style={{
                      // marginLeft: currentUser.isPowerUser ? "10px" : "20px",
                      // minWidth: currentUser.isPowerUser ? "160px" : "",
                        marginLeft:"10px",
                      minWidth:  "160px" ,
                    }}
                  >
                    {entry.locationInfo.name}
                  </div>
                </div>
                {/* {currentUser.isPowerUser && ( */}
                  <div
                    style={{
                      marginLeft: "16px",
                    }}
                  >
                    {!isAvailableCountLoading ? (
                      <div
                        style={{
                          color:
                            entry.seats > 0 ? "black" : "#be0606",
                          fontWeight: "bold" ,
                          width: "100%",
                          textAlign: "center",
                          paddingRight: "40px"
                        }}
                      >
                        {entry.seats}
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          paddingRight: "40px",
                        }}
                      >
                        {" "}
                        <Spinner
                          className="me-1"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </div>
                    )}
                  </div>
                 {/* )} */}
                <div
                  style={{
                    // paddingLeft: currentUser.isPowerUser ? "0px" : "38px",
                    // paddingRight: currentUser.isPowerUser ? "10px" : "",
                     paddingLeft: "0px" ,
                    paddingRight: "10px" ,
                  }}
                >
                  <button
                    className="button"
                    style={{ width: "max-content" }}
                    onClick={() => {
                      setSessionForEnroll(entry.sessions);
                      setSessionLength(entry.sessions.sessions.length);
                      setSelectedLocation(entry.locationInfo);
                      if (currentUser.isPowerUser) {
                        setProwerUserMsg(true);
                        defaultListGroupOptions.length <= 0 &&
                          getPowerUserGroups();
                      }
                      onViewSessionClickHandler(entry.sessions.sessions);
                      setShowViewFullScheduleList(true);
                      sessionForEnrollSelectionRef.current =
                        entry.sessions.sessions;
                    }}
                  >
                    View Full Schedule
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "200px",
              }}
            >
              No record(s) found.
            </div>
          )}
        </div>
      )}

      <LocationModal
        isOpen={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        location={selectedLocation}
      />

      <FullScheduleModal
        isOpen={showViewFullScheduleList}
        isPowerUser={currentUser.isPowerUser}
        onClose={() => setShowViewFullScheduleList(false)}
        onEnrollClickHandler={onEnrollClickHandler}
        title="Full Schedule"
        isAvailableCountLoading={isAvailableCountLoading}
        availableSeats={hasZeroSeats}
        subtitle={
          <div
            style={{
              display: "inline-flex",
              flexWrap: "wrap",
              gap: "4px",
            }}
          >
                {
                    selectedCity === "Webinar" ? (<>This will enroll you into the webinar classes.
                    </>) : (<>This will enroll you in the available classes at
                        <span>{selectedCity}</span>{" "}
                        {selectedCityAddress?.length > 0 ? " -" : ""}</>)
                }
            <span
              className="fullScheduleLocationLinkText"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();

                  setShowLocationModal(true);
                }
              }}
              onClick={() => setShowLocationModal(true)}
            >
              {selectedCityAddress}
            </span>
          </div>
        }
      >
        {isAvailableCountLoading ? (
          <div
            style={{
              width: "100%",
              height: "50vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner
              className="me-1"
              as="span"
              animation="border"
              size="lg"
              role="status"
              aria-hidden="true"
            />
          </div>
        ) : (
          <div
            className="full-schedule-table"
            style={{
              maxHeight:
                currentUser.isPowerUser && hasZeroSeats ? "58vh" : "60vh",
            }}
          >
            {otherSessionList?.length > 0 && (
              <div className="full-schedule-table-header">
                <div>Date & Location</div>
                <div style={{ marginLeft: "4px" }}>Start & End Time (PT)</div>
                <div></div>
                <div style={{paddingRight:"20px"}}>Module Name</div>
                <div>Available Seats</div>
              </div>
            )}

            <div className="full-schedule-table-scroll">
              {otherSessionList?.length > 0 ? (
                otherSessionList.map(([date, sessions], index) => (
                  <div key={index} className="full-schedule-table-row-group">
                    <div className="class-date-location">
                      <div className="class-date">{date}</div>
                    </div>
                    {sessions.map((entry, subIndex) => (
                      <div key={subIndex} className="full-schedule-table-row">
                        <div className="class-location">
                          {entry.locationType === "onsite" ? (
                            <img
                              src={online}
                              style={{
                                width: "14px",
                                marginBottom: "5px",
                                marginRight: "2px",
                              }}
                              alt="In-Person"
                            />
                          ) : (
                            <img
                              src={onsite}
                              style={{
                                width: "16px",
                                marginBottom: "4px",
                                marginRight: "2px",
                              }}
                              alt="Webinar"
                            />
                          )}
                          <div style={{ marginLeft: "4px" }}>
                            {entry.locationType === "onsite"
                              ? "In-Person"
                              : "Webinar"}
                          </div>
                        </div>

                        <div className="class-time">
                          {entry.startTime} - {entry.endTime}
                        </div>
                        <div className="class-duration">{entry.duration}</div>
                        <div className="class-module">{entry?.module}</div>
                        <div
                          className="class-seats"
                          style={{
                            marginLeft: "16px",
                              color: entry.seats > 0 ? "black" : "#be0606",
                            fontWeight: "bold",
                          }}
                        >
                          {entry.seats}
                        </div>
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "200px",
                  }}
                  className="no-record"
                >
                  No record(s) found.
                </div>
              )}
            </div>
          </div>
        )}
      </FullScheduleModal>

      <ConfirmationScreen
        isOpen={showViewDashboardPopup}
        onClose={() => setShowViewDashboardPopup(false)}
      >
        <div className="confirmation-content">
          <div className="confirmation-message">
            <div className="confirmation-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 64 64"
                fill="none"
              >
                <circle cx="32" cy="32" r="32" fill="#0DB421" />
                <path
                  d="M18 33L28 43L46 25"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            
{currentUser.isPowerUser ? (
    <div className="confirmation-title">
     Below are the details of your enrollment.
    </div>
  ) : (
    <>
      {result?.enrolled?.length > 0 && (
        <div className="confirmation-title">
          {currentUser.username}, You have successfully enrolled in{" "}
          {result.enrolled.length} classes.
        </div>
      )}

      {result?.existing_enrollments?.length > 0 && (
        <div className="confirmation-title" style={{ color: "red" }}>
          {currentUser.username}, Already enrolled in{" "}
          {result.existing_enrollments.length} out of {sessionLength} classes!
        </div>
      )}
    </>
  )}

            
            
            <div className="confirmation-note">
              <span className="note-highlight">
                Note: If you are unable to make a class,
              </span>{" "}
              you may reschedule it on
              <br />
              the class page.
            </div>
          </div>

          <div className="confirmation-actions" style={{ marginBottom: "8px" }}>
            <div style={{ marginRight: "8px" }}>
              {currentUser.isPowerUser ? (
                <button
                  className="button"
                  onClick={() =>
                    (selectBoxValuesGroup?.label ?? "")
                      .toLowerCase()
                      .includes("employer".toLowerCase())
                      ? (window.top.location.href =
                          process.env.REACT_APP_EMPLOYERS_HOME_PAGE_URL)
                      : (window.top.location.href =
                          process.env.REACT_APP_MRC_HOME_PAGE_URL)
                  }
                >
                  {(selectBoxValuesGroup?.label ?? "")
                    .toLowerCase()
                    .includes("employer".toLowerCase())
                    ? "Employer Home Page"
                    : "MRC Home Page"}
                </button>
              ) : (
                <button
                  className="button"
                  onClick={() =>
                    (window.top.location.href =
                      selectedLearningPlan.dashboardUrl)
                  }
                >
                  View my Dashboard
                </button>
              )}
            </div>
            {currentUser.isPowerUser ? (
              <div  style={{ marginRight: "8px" }}>
                <button className="button" onClick={onGoToEnrollmentClick}>
                  Go to Enrollment
                </button>
              </div>
            ) : (
              <div></div>
            )}
             {
            result?.enrolled?.length>0 && <div ><button className="button" onClick={() => handlePrintData(enrolledSessionList,result,currentUser)}>Print</button></div>
          }
          </div>
          {/* {
            result?.enrolled?.length>0 && <div style={{ display: "flex", justifyContent: "flex-end" }}><button className="button" onClick={() => handlePrintData(enrolledSessionList,result,currentUser)}>Print</button></div>
          } */}

          <div className="confirmation-schedule-table-body">
            <div className="confirmation-schedule-table-header">
              <div>Date & Location</div>
              <div style={{ marginLeft: "4px" }}>Start & End Time (PT)</div>
              <div></div>
              <div>Module Name</div>
              <div>Status</div>
            </div>

            <div
              className={`confirmation-schedule-table-scroll ${
                enrolledSessionList?.length > 0 ? "has-data" : ""
              }`}
            >
              {enrolledSessionList?.length > 0 ? (
                enrolledSessionList.map((group, index) => (
                  <div
                    key={index}
                    className="confirmation-schedule-table-row-group"
                  >
                    <div className="class-date-location">
                      <div className="class-date">{group["0"]}</div>
                    </div>

                    {group["1"].map((entry, subIndex) => (
                      <div
                        key={subIndex}
                        className="confirmation-schedule-table-row"
                      >
                        <div className="class-location">
                          {entry.locationType === "onsite" ? (
                            <img
                              src={online}
                              style={{
                                width: "14px",
                                marginBottom: "5px",
                                marginRight: "2px",
                              }}
                              alt="In-Person"
                            />
                          ) : (
                            <img
                              src={onsite}
                              style={{
                                width: "16px",
                                marginBottom: "4px",
                                marginRight: "2px",
                              }}
                              alt="Webinar"
                            />
                          )}
                          <div style={{ marginLeft: "4px" }}>
                            {entry.locationType === "onsite"
                              ? "In-Person"
                              : "Webinar"}
                          </div>
                        </div>

                        <div className="class-time">
                          {entry.startTime} - {entry.endTime}
                        </div>
                        <div className="class-duration">{entry.duration}</div>
                        <div className="class-module">{entry.module}</div>
                        {currentUser.isPowerUser ? (<div>
{result?.enrolled?.filter(e => e.id_course === Number(entry.courseId)).length > 0 && (
  
                                    <p style={{ color: "green" }}> Enrolled:{" "}
    {result.enrolled
      .filter(e => e.id_course === Number(entry.courseId))
                                            .map((e) => {
                                                const user = selectBoxValues.find(
                                                    (u) => u.value === e.id_user
                                                );
                                                return user?.label;
                                            })
                                            .filter(Boolean)
      .join(", ")}
  </p>
)}

                       {result?.extsingEnroll_Data?.filter(e => e.id_course === Number(entry.courseId)).length > 0 && (
  <p style={{color:"red"}}>
                                        Already Enrolled:{" "}
    {result.extsingEnroll_Data
      .filter(e => e.id_course === Number(entry.courseId))
                                            .map((e) => {
                                                const user = selectBoxValues.find(
                                                    (u) => u.value === e.id_user
                                                );
                                                return user?.label;
                                            })
                                            .filter(Boolean)
      .join(", ")}
  </p>
)}

                         {result?.penddingsessions?.filter(e => Number(e.id_course) === Number(entry.courseId)).length > 0 && (
  <p style={{color:"blue"}}>
                                        Not Enrolled: {" "}
    {result.penddingsessions
      .filter(e => Number(e.id_course) === Number(entry.courseId))
                                            .map((e) => {
                                                const user = selectBoxValues.find(
                                                    (u) => u.value === e.id_user
                                                );
                                                return user?.label;
                                            })
                                            .filter(Boolean)
      .join(", ")}
  </p>
)}</div>
                        ):(<div
                          className="class-module"
                          style={{
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            justifyItems: "center",
                            width: "100%",
                            textWrap: "nowrap",
                            color:
                              entry.enrolledStatus === "Enrolled"
                                ? "green"
                                : "red",
                          }}
                        >
                          {entry.enrolledStatus || "-"}
                        </div>)}
                        
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "200px",
                  }}
                >
                  No record(s) found.
                </div>
              )}
            </div>
          </div>
        </div>
      </ConfirmationScreen>

      {currentUser.isPowerUser ? (
        <Modal
          centered
          show={showEnrollModal}
          onHide={() => {
            setShowEnrollModal(false);
            setSelectBoxValues([]);
          }}
        >
          <ModalHeader
            style={{
              height: "50px",
              backgroundColor: "#e4e1ef",
              paddingRight: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
              }}
            >
              <div className="container-heading" style={{ color: "#441968" }}>
                Select group and users for enrollment
              </div>
              <CustomTooltip text="Close" placement="top">
                <button
                  className="btn-close"
                  style={{ color: "black", marginRight: "4px" }}
                  onClick={() => setShowEnrollModal(false)}
                ></button>
              </CustomTooltip>
            </div>
          </ModalHeader>
          <Modal.Body>
            <div className="row">
              <div className="mb-3">
                Select Group{" "}
                <Select
                  ref={enrollSelectBox}
                  options={defaultListGroupOptions}
                  onChange={handleSelectChangeGroup}
                  isLoading={isListBoxLoading}
                  filterOption={filterOptions}
                  value={selectBoxValuesGroup}
                />
              </div>
              <div className="mb-3">
                Select Users{" "}
                <Select
                  ref={enrollSelectBox}
                  options={defaultListOptions}
                  isMulti
                  onChange={setSelectBoxValues}
                  isLoading={isListBoxLoading}
                  filterOption={filterOptions}
                />
              </div>
            </div>
            <div hidden={!loading} className=""></div>
          </Modal.Body>
          <Modal.Footer>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "14px",
              }}
            >
              <button
                className="secondary_button"
                style={{ width: "120px" }}
                onClick={() => {
                  setShowEnrollModal(false);
                }}
              >
                Close
              </button>
              <button
                style={{ width: "120px" }}
                className={`${
                  !selectBoxValues || selectBoxValues.length === 0
                    ? "button-disabled"
                    : "button"
                }`}
                disabled={
                  loading || !selectBoxValues || selectBoxValues.length === 0
                }
                onClick={(e) => onModalEnrollClickHandler(e)}
              >
                <Spinner
                  className="me-1"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  hidden={!loading}
                />
                Enroll
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      ) : (
        <Modal
          centered
          show={showEnrollConfirm}
          onHide={() => setShowEnrollConfirm(false)}
        >
          <Modal.Header style={{ borderBottom: "none" }}>
            <span
              style={{
                fontWeight: "bold",
                fontSize: "22px",
                paddingLeft: "4px",
              }}
            >
              Confirm Enrollment
            </span>
            <CustomTooltip text="Close" placement="top">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setShowEnrollConfirm(false)}
              ></button>
            </CustomTooltip>
          </Modal.Header>

          <Modal.Body style={{ borderTop: "none", borderBottom: "none" }}>
            <div className="row">
              <div className="mb-3" style={{ whiteSpace: "pre-line" }}>
                {conformationText}
              </div>
            </div>
            <div hidden={!loading}></div>
          </Modal.Body>
          <Modal.Footer
            className="d-flex justify-content-center gap-2 w-full"
            style={{ borderTop: "none" }}
          >
            <button
              className="btn btn-secondary"
              style={{
                backgroundColor: "white",
                color: "#007fa3",
                border: "1px solid #007fa3",
                width: "120px",
              }}
              onClick={() => {
                setShowEnrollConfirm(false);
              }}
            >
              Close
            </button>
            <button
              className="btn secondary"
              style={{
                width: "120px",
              }}
              disabled={loading}
              onClick={(e) => onConfirmEnrollClick(e)}
            >
              <Spinner
                className="me-1"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                hidden={!loading}
              />
              Confirm
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default ScheduleList;
